import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { getUserRoles } from '../models/roles.model';
import { ConfigService } from '../config.service';
import { ProfileService } from '../services/profile.service';

export const authorizationGuard: CanActivateFn = async () => {
  const profileService = inject(ProfileService);
  const configService = inject(ConfigService);
  const document = inject(DOCUMENT);

  try {
    await profileService.initialize();
  } catch (error) {
    console.error('Authorization failed; returning to the home page:', error);
    return redirectHome(document, configService.homeUrl);
  }

  const roles: Record<string, boolean> = getUserRoles();
  const hasAnyAuthorizedRole: boolean = Object.values(roles).some(Boolean);

  if (!hasAnyAuthorizedRole) {
    return redirectHome(document, configService.homeUrl);
  }

  return true;
};

function redirectHome(document: Document, homeUrl: string): false {
  const url = homeUrl.trim();
  if (url) {
    document.location.href = url;
  } else {
    // An empty href would reload this app in a loop.
    console.error('Not redirecting: home_url is not configured');
  }
  return false;
}
